import Actions from 'reducers/PlayList'
import { thunks as PlayQueueThunks } from 'reducers/PlayQueue'
import { PlayListService } from 'services'
import { storeHelpers } from 'utils'
import { PlaylistSort } from 'constants/enums'
import { maxPagesize } from 'config'
import type { AppDispatch } from 'types/store'

export const list =
  ({ page, pagesize, summary }: { page: number; pagesize?: number; summary?: boolean }) =>
  (dispatch: AppDispatch) => {
    storeHelpers.asyncGetStoreState().then(({ playList }: any) => {
      const { searchToken, sort } = playList
      PlayListService.list(page, pagesize, searchToken, sort, summary)
        .then((response: any) => {
          const items = response.data.items
          const totalItemsCount = response.data.total
          dispatch(Actions.loadingPlaylistSuccess(items, page, totalItemsCount))
        })
        .catch((error: any) => {
          console.warn(error)
        })
    })
  }

export const listAll = () => (dispatch: AppDispatch) => {
  PlayListService.list(1, maxPagesize, undefined, PlaylistSort.newest.value, true)
    .then((response: any) => {
      const items = response.data.items
      dispatch(Actions.setPlaylistAbstracts(items))
    })
    .catch((error: any) => {
      console.warn(error)
    })
}

export const create =
  (playList: any, successCallBack?: (data: any) => void) =>
  (dispatch: AppDispatch) => {
    PlayListService.create(playList)
      .then((response: any) => {
        dispatch(list({ page: 1 }) as any)
        dispatch(listAll() as any)
        if (successCallBack) {
          successCallBack(response.data)
        }
      })
      .catch((error: any) => {
        console.warn(error)
      })
  }

export const refreshPlaylist =
  (id: string, successCallBack?: (playlist: any) => void) =>
  (dispatch: AppDispatch) => {
    PlayListService.getPlaylist(id)
      .then((response: any) => {
        const playlist = response.data
        PlayListService.getTracklist(id).then((response2: any) => {
          playlist.songs = response2.data.items
          dispatch(Actions.updatePlaylist(playlist))
          if (successCallBack) {
            successCallBack(playlist)
          }
        })
      })
      .catch((e: any) => console.error(e))
  }

export const updatePlaylist =
  (playlist: any, successBlock: (() => void) | null = null) =>
  (dispatch: AppDispatch) => {
    PlayListService.updateItem(playlist)
      .then(() => {
        if (successBlock) {
          successBlock()
        }
        dispatch(refreshPlaylist(playlist.playlistid) as any)
        dispatch(PlayQueueThunks.updatePlaylist(playlist))
      })
      .catch((e: any) => console.warn(e))
  }

export const deletePlaylist =
  (playlist: any, onSuccess?: () => void) => (dispatch: AppDispatch) => {
    dispatch(Actions.deletePlaylistStart())
    PlayListService.deleteItem(playlist.playlistid)
      .then(() => {
        dispatch(Actions.deletePlaylistSuccess(playlist))
        dispatch(PlayQueueThunks.deletePlaylist(playlist))
      })
      .then(() => {
        if (typeof onSuccess === 'function') {
          onSuccess()
        }
      })
      .catch((error: any) => {
        console.warn(error)
        dispatch(Actions.deletePlaylistError())
      })
  }

export const deleteSong =
  (playlist: any, song: any) => (dispatch: AppDispatch) => {
    dispatch(Actions.updateLoadingPlaylist(true))
    PlayListService.deleteTrack(playlist, song)
      .then(() => {
        dispatch(refreshPlaylist(playlist.playlistid) as any)
        dispatch(Actions.updateLoadingPlaylist(false))
      })
      .catch(() => {
        dispatch(Actions.updateLoadingPlaylist(false))
      })
  }

export const deleteAllSongs = (playlist: any) => (dispatch: AppDispatch) => {
  dispatch(Actions.updateLoadingPlaylist(true))
  PlayListService.deleteAllTrack(playlist)
    .then(() => {
      dispatch(
        refreshPlaylist(playlist.playlistid, () => {
          dispatch(Actions.updateLoadingPlaylist(false))
        }) as any
      )
    })
    .catch(() => {
      dispatch(Actions.updateLoadingPlaylist(false))
    })
}

export const addTracks =
  (id: string, tracks: any[], successBlock: ((data: any) => void) | null = null) =>
  (dispatch: AppDispatch) => {
    dispatch(Actions.addTracksStart())
    PlayListService.addTracks(id, tracks)
      .then((response: any) => {
        if (successBlock) {
          successBlock(response.data)
        }
        dispatch(refreshPlaylist(id) as any)
        dispatch(Actions.addTracksSuccess())
      })
      .catch((error: any) => {
        console.warn(error)
        dispatch(Actions.addTracksFail())
      })
  }

export const pin = (playlist: any) => (dispatch: AppDispatch) => {
  PlayListService.pin(playlist)
    .then(() =>
      dispatch(Actions.pinPlaylist(Object.assign({}, playlist, { pinned: true })))
    )
    .catch()
}

export const unpin = (playlist: any) => (dispatch: AppDispatch) => {
  PlayListService.unpin(playlist)
    .then(() =>
      dispatch(Actions.unpinPlaylist(Object.assign({}, playlist, { pinned: false })))
    )
    .catch()
}

export default {
  list,
  listAll,
  create,
  deleteSong,
  refreshPlaylist,
  deleteAllSongs,
  addTracks,
  updatePlaylist,
  deletePlaylist,
  pin,
  unpin,
}
